import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/app/routes';

/**
 * Sign out and land on sign-in: the same from the rail and from the menu.
 *
 * It navigates first and leaves the clearing to the sign-in page, which reads
 * the marker carried in the navigation state. Clearing here would end the
 * session before a dirty form's leave prompt could hold the navigation - and
 * choosing Stay must leave the person signed in, on the page, with their
 * edits.
 */
export function useLogOut() {
  const navigate = useNavigate();

  return () => {
    // replace, so the browser's back button does not appear to restore the
    // portal after signing out.
    void navigate(ROUTES.signIn, { replace: true, state: { loggingOut: true } });
  };
}
